// Giờ cho view có đếm ngược (chip giờ, hàng đợi lò): vẽ lại theo nhịp đồng hồ UI 30s (TECH_BASELINE
// §6.2), còn giá trị đọc `now()` ngay lúc vẽ, nên vẽ lại vì signal khác (vừa bấm luyện, vừa thu) cũng
// không dùng giờ cũ của nhịp trước.
import { useEffect, useState } from 'preact/hooks';
import { now, onTick } from '@state/clock';

export function useClock(): number {
  const [, setTick] = useState(0);
  useEffect(() => onTick(setTick), []);
  return now();
}
